<template>
  <div :class="className">
    <a
      v-perm="access"
      href="javascript:void(0);"
      :loading="loading"
      type="link"
      danger
      @click="showDialog"
      style="color: #ff4d4f"
    >
      丢单
    </a>
    <a-modal
      :confirmLoading="loading"
      v-model:visible="visible"
      title="丢单记录 "
      :centered="true"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form layout="vertical" ref="formRef" :model="formModel" :rules="formRules">
        <a-form-item label="丢单原因" name="projectDiscardReason">
          <dict-select-lost-order
            v-model:value="formModel.projectDiscardReason"
            code="throwSingle_reason"
          ></dict-select-lost-order>
        </a-form-item>
        <a-form-item label="丢单备注" name="remark">
          <a-textarea
            show-count
            v-model:value="formModel.remark"
            placeholder="请输入说明，最多200字"
            :auto-size="{ minRows: 3 }"
            :maxlength="200"
            allowClear
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, ref } from "vue";
import { Form } from "ant-design-vue";
import { ProfileService } from "@/views/project/profile/profile.service";
import { message } from "ant-design-vue";
import { getCurrentTenantId } from "@/utils";
import DictSelectLostOrder from "./dict-select/index.vue";

export default defineComponent({
  name: "LostOrderBtnNew",
  isGlobal: true,
  components: { DictSelectLostOrder },
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    bizName: {
      type: String,
      required: true,
    },
    access: { type: String },
    loading: {
      type: Boolean,
    },
    className: {
      type: String,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const state = reactive({
      visible: false,
      formModel: {
        projectDiscardReason: undefined,
        remark: "",
      },
      formRef: ref(),
    });
    const formRules = {
      projectDiscardReason: [{ required: true, message: "请选择丢单原因", trigger: "change" }],
    };
    const showDialog = () => {
      state.visible = true;
    };
    const cancel = () => {
      state.formRef.resetFields();
    };
    const { run, loading } = ProfileService.useThrowSingleApi();
    const handleOk = async () => {
      try {
        // console.log(state.formModel);
        await state.formRef.validate();
        emit("update:loading", true);
        const { bizId } = props;
        const data = {
          tenantId: getCurrentTenantId(),
          projectId: bizId,
          ...state.formModel,
        };
        let res = await run(data);
        if (res.respCode !== "0000") {
          message.error(res.respDesc);
          return;
        }
        message.success(res.respDesc);
        emit("refresh", null);
        state.visible = false;
      } finally {
        emit("update:loading", false);
      }
    };
    const reason = ref("");
    return {
      ...toRefs(state),
      showDialog,
      handleOk,
      loading,
      formRules,
      reason,
      cancel,
    };
  },
});
</script>

<style scoped>
.approval-dialog__subtitle {
  color: #6d6d6d;
  position: absolute;
  top: 16px;
  left: 128px;
  font-size: 14px;
}
</style>
